import { render, staticRenderFns } from "./PaymentMethodSetup.vue?vue&type=template&id=57902831&"
import script from "./PaymentMethodSetup.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports